import { VendorLocationData } from "./types";
import { SalesByDayTable } from "./SalesByDayTable";
import { FinancialSummary } from "./FinancialSummary";

interface VendorDetailProps {
  data: VendorLocationData;
}

export const VendorDetail = ({ data }: VendorDetailProps) => (
  <div className="px-4 pb-4 space-y-4">
    {/* Sales by Day */}
    <Section title="Sales by Day">
      <SalesByDayTable
        items={data.items}
        eventDays={data.eventDays}
        dayTotals={data.dayTotals}
        tips={data.tips}
      />
    </Section>

    {/* Financial Summary */}
    <Section title="Financial Summary">
      <FinancialSummary
        grossSales={data.grossSales}
        grossCredit={data.grossCredit}
        grossRfid={data.grossRfid}
        grossCashBalance={data.grossCashBalance}
        salesTax={data.salesTax}
        netSales={data.netSales}
        revenueShare={data.revenueShare}
        commissionAmount={data.commissionAmount}
        vendorCommission={data.vendorCommission}
        eventName={data.eventName}
      />
    </Section>
  </div>
);

export const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div className="border border-gray-200 rounded-lg overflow-hidden">
    <div className="bg-gray-800 px-3 py-1.5">
      <h3 className="text-xs font-semibold text-white uppercase tracking-wide">{title}</h3>
    </div>
    <div className="p-3">{children}</div>
  </div>
);
